export default __webpack_public_path__ + "static/media/sketch1.c097de40.jpg";